import { GetOrderProductsDocument } from '../magento'

/** @deprecated use imported document */
export const GET_ORDER_PRODUCTS = GetOrderProductsDocument
